var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolInboundMarketing01 = function SvgSolInboundMarketing01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_inbound_marketing-01_svg2__a",
    x1: 75.46,
    x2: 255.6,
    y1: 247.62,
    y2: 63.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_inbound_marketing-01_svg2__a",
    id: "sol_inbound_marketing-01_svg2__b",
    x1: -47.03,
    x2: 133.11,
    y1: 127.76,
    y2: -56.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_inbound_marketing-01_svg2__a",
    id: "sol_inbound_marketing-01_svg2__c",
    x1: 13.61,
    x2: 193.75,
    y1: 187.09,
    y2: 3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_inbound_marketing-01_svg2__a",
    id: "sol_inbound_marketing-01_svg2__d",
    x1: 14.22,
    x2: 194.36,
    y1: 187.69,
    y2: 3.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_inbound_marketing-01_svg2__a",
    id: "sol_inbound_marketing-01_svg2__e",
    x1: 14.88,
    x2: 195.02,
    y1: 188.34,
    y2: 4.24
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.61 121.21c-21.72 0-39.4 17.67-39.4 39.39 0 8.21 2.51 16.08 7.23 22.72.11.2.25.39.38.52 7.41 10.12 19.3 16.16 31.79 16.16s23.2-5.39 30.7-14.75c.16-.16.3-.34.39-.49 5.43-6.97 8.3-15.33 8.3-24.16 0-21.72-17.67-39.39-39.39-39.39m-.63 18.94c7.05 0 12.79 5.73 12.79 12.77s-5.73 12.79-12.79 12.79-12.79-5.74-12.79-12.79 5.73-12.77 12.79-12.77m-7.4 29.76c4.7 2.05 10.1 2.05 14.79 0 10.04 1.65 16.87 6.22 18.79 12.56-6.42 7.49-15.71 11.78-25.55 11.78-10.38 0-20-4.68-26.44-12.86 2.36-5.77 9.04-9.94 18.4-11.49Zm25.92-16.98c0-10.21-8.31-18.51-18.52-18.51s-18.53 8.31-18.53 18.51c0 4.68 1.73 9.09 4.88 12.52-7 2.05-12.52 5.73-15.69 10.45a33.7 33.7 0 0 1-3.68-15.3c0-18.55 15.1-33.65 33.66-33.65s33.65 15.09 33.65 33.65c0 5.74-1.47 11.39-4.26 16.38-3.03-5.27-8.79-9.32-16.37-11.53a18.4 18.4 0 0 0 4.88-12.51Z",
    style: {
      fill: "url(#sol_inbound_marketing-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66 62.68c7.42 10.09 19.28 16.11 31.76 16.11s23.18-5.38 30.67-14.7c.19-.18.36-.39.46-.57 5.41-6.96 8.27-15.3 8.27-24.11 0-21.73-17.68-39.4-39.4-39.4S.03 17.68.03 39.41c0 8.2 2.51 16.07 7.22 22.7.11.2.25.39.41.57m31.13-43.72c7.04 0 12.77 5.74 12.77 12.79s-5.73 12.79-12.77 12.79S26 38.8 26 31.75s5.74-12.79 12.79-12.79m-7.41 29.75c4.7 2.06 10.13 2.06 14.82 0 10.02 1.66 16.84 6.22 18.77 12.56-6.42 7.49-15.72 11.78-25.55 11.78-10.37 0-19.99-4.68-26.43-12.85 2.34-5.76 9.02-9.93 18.39-11.49m25.93-16.97c0-10.21-8.31-18.53-18.51-18.53s-18.52 8.31-18.52 18.53c0 4.67 1.73 9.08 4.88 12.51-7 2.06-12.52 5.73-15.69 10.45a33.7 33.7 0 0 1-3.68-15.3C5.77 20.85 20.87 5.75 39.42 5.75s33.66 15.1 33.66 33.66c0 5.74-1.47 11.39-4.27 16.38-3.03-5.27-8.79-9.33-16.37-11.54 3.14-3.43 4.87-7.84 4.87-12.51",
    style: {
      fill: "url(#sol_inbound_marketing-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.16 134.89c-1.08-1.08-2.98-1.09-4.06 0l-32.08 32.08c-3.51 3.51-8.19 5.45-13.17 5.45s-9.66-1.93-13.17-5.45c-3.49-3.49-5.41-8.17-5.41-13.18s1.92-9.68 5.41-13.17l32.07-32.07c.53-.53.84-1.27.84-2.03s-.31-1.5-.84-2.03L49.54 89.28c-1.08-1.09-2.98-1.08-4.06 0l-32.07 32.08c-17.88 17.89-17.88 46.99 0 64.87 8.65 8.65 20.17 13.41 32.44 13.41s23.78-4.76 32.43-13.41l32.07-32.07a2.873 2.873 0 0 0 0-4.06l-15.2-15.21Zm-58.18-28.98 10.53-10.53 11.15 11.15-10.53 10.53zM21.52 153.8c0 6.54 2.52 12.66 7.09 17.24 9.5 9.5 24.95 9.5 34.45 0l15.46-15.46 11.15 11.14-15.45 15.45c-15.65 15.64-41.1 15.64-56.75 0-15.64-15.64-15.64-41.1 0-56.75l15.45-15.45 11.15 11.15-15.45 15.45c-4.57 4.57-7.1 10.69-7.1 17.23m82.74-1.67-10.54 10.53-11.14-11.14 10.54-10.54z",
    style: {
      fill: "url(#sol_inbound_marketing-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.61 95.32h-10.16V79.66c0-1.17-.7-2.21-1.77-2.65-1.08-.45-2.31-.2-3.13.62L80.39 99.79c-.82.82-1.07 2.05-.62 3.13a2.86 2.86 0 0 0 2.65 1.77h10.16v15.65c0 1.17.7 2.21 1.77 2.65a2.868 2.868 0 0 0 3.13-.62l22.16-22.15c.82-.82 1.07-2.05.62-3.13a2.86 2.86 0 0 0-2.65-1.77m-22.16 3.63h-6.1l12.36-12.36v11.6c0 1.58 1.29 2.87 2.87 2.87h6.1l-12.36 12.35v-11.59c0-1.58-1.29-2.87-2.87-2.87",
    style: {
      fill: "url(#sol_inbound_marketing-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.86 62.69c7.42 10.08 19.28 16.1 31.75 16.1s23.18-5.38 30.67-14.71c.19-.18.35-.38.44-.55 5.41-6.97 8.28-15.31 8.28-24.13C200 17.68 182.33.01 160.61.01s-39.4 17.67-39.4 39.4c0 8.2 2.51 16.06 7.22 22.69.11.21.26.41.43.59m37.09-19.09-.26-.43c-3.55 1.78-7.82 1.79-11.34.05l-.15-.08c-4.32-2.2-7.01-6.57-7.01-11.4 0-7.05 5.73-12.79 12.79-12.79s12.79 5.74 12.79 12.79c0 4.85-2.7 9.22-7.04 11.41l.23.44Zm-13.38 5.11c4.7 2.06 10.13 2.06 14.82 0 10.03 1.66 16.85 6.22 18.77 12.56-6.42 7.49-15.72 11.78-25.55 11.78-10.38 0-20-4.68-26.44-12.85 2.35-5.76 9.03-9.93 18.39-11.49Zm25.93-16.97c0-10.21-8.31-18.53-18.52-18.53s-18.53 8.31-18.53 18.53c0 4.67 1.73 9.09 4.88 12.52-7 2.06-12.51 5.73-15.69 10.45a33.7 33.7 0 0 1-3.68-15.3c0-18.56 15.1-33.66 33.66-33.66s33.65 15.1 33.65 33.66c0 5.74-1.47 11.38-4.26 16.37-3.03-5.27-8.78-9.33-16.36-11.53 3.15-3.43 4.87-7.83 4.87-12.51Z",
    style: {
      fill: "url(#sol_inbound_marketing-01_svg2__e)"
    }
  }));
};
export default SvgSolInboundMarketing01;